import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/docrates-icon-screening.svg'


const _withScopeId = n => (_pushScopeId("data-v-6008a578"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "div-category-selectables-base" }
const _hoisted_2 = { class: "div-category-selectables-heading" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "div-category-selectables-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    id: "img-category-selectables-content",
    src: _imports_0
  })
], -1))
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "div-category-selectables-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_category_service_card = _resolveComponent("category-service-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("h2", {
        id: "category-selectables-h2",
        innerHTML: 
          _ctx.store.getters.translate(
            'category-services-appointment-early-detection-heading'
          )
        
      }, null, 8, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_category_service_card, {
        onSelected: _ctx.serviceSelectedInComponent,
        categoryServiceType: "psa-test",
        heading: _ctx.store.getters.translate('category-service-card-psa-heading'),
        "text-1": _ctx.store.getters.translate('category-service-card-psa-text-1')
      }, null, 8, ["onSelected", "heading", "text-1"]),
      _createVNode(_component_category_service_card, {
        onSelected: _ctx.serviceSelectedInComponent,
        categoryServiceType: "fit-test",
        heading: _ctx.store.getters.translate('category-service-card-fit-heading'),
        "text-1": _ctx.store.getters.translate('category-service-card-fit-text-1')
      }, null, 8, ["onSelected", "heading", "text-1"]),
      _createVNode(_component_category_service_card, {
        onSelected: _ctx.serviceSelectedInComponent,
        categoryServiceType: "mole-screening",
        heading: _ctx.store.getters.translate('category-service-card-mole-screening-heading'),
        "text-1": _ctx.store.getters.translate('category-service-card-mole-screening-text-1')
      }, null, 8, ["onSelected", "heading", "text-1"])
    ])
  ]))
}